import { csrfToken } from '@/js/_common';

const getFavoriteType = (target) => target.dataset.favoriteType || 'job';

const getApiUrl = (target) => {
    if (target.dataset.apiUrl) return target.dataset.apiUrl;
    if (getFavoriteType(target) === 'magazine') {
        return `/api/user/magazine/favorite/${target.dataset.id}`;
    }
    return `/api/user/favorite/${target.dataset.id}`;
}

const action = async (target, active) => {
    const id = target.dataset.id;
    if (!id) return;
    const url = getApiUrl(target);
    const params = {
        method: active ? 'POST' : 'DELETE',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrfToken,
        },
    }

    return await fetch(url, params)
        .then(resp => {
            return resp.json()
        })
}

export const setEvent = (el) => {
    el.addEventListener('click', async (e) => {
        const target = e.currentTarget;
        e.preventDefault();
        e.stopPropagation();
        const nextState = target.dataset.active !== '1';
        target.dataset.active = target.dataset.active == '1' ? 0 : 1;
        if (nextState) {
            target.classList.add('is-active');
        } else {
            target.classList.remove('is-active');
        }
        const resp = await action(target, nextState);
        if ('status' in resp && resp.status === 'success') {
            const favoriteType = getFavoriteType(target);
            document.querySelectorAll(`.c-parts-favorite[data-favorite-type="${favoriteType}"][data-id="${target.dataset.id}"], a[data-type="favorite"][data-favorite-type="${favoriteType}"][data-id="${target.dataset.id}"]`).forEach((obj) => {
                obj.dataset.active = target.dataset.active;
                obj.classList.remove('is-active');
            });
        } else {
            target.dataset.active = target.dataset.active == '1' ? 0 : 1;
        }
    });
}

const main = () => {
    if (document.querySelector('.c-parts-favorite') == null) return;

    document.querySelectorAll('.c-parts-favorite').forEach((el) => {
        setEvent(el);
    });
}

export default main;
